import React, { memo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Button, Flex, Heading, Text } from '@qga/roo-ui/components';
import { useDialog } from 'components/Dialog';
import { ContactLinks, CallCenterHours } from 'components/CheckoutPage/BookingErrorDialogs/textSnippets';
import { useDataLayer } from 'hooks/useDataLayer';
import { getIsExclusive, getIsLoading as getIsPropertyLoading } from 'store/property/propertySelectors';
import { getExclusiveOffer, getIsLoading as getIsExclusiveLoading } from 'store/exclusiveOffer/exclusiveOfferSelectors';

const ExclusiveOfferUnavailableDialog = memo(() => {
  const { Dialog, openDialog } = useDialog({ initialiseOpen: false });
  const { emitInteractionEvent } = useDataLayer();
  const isExclusive = useSelector(getIsExclusive);
  const isPropertyLoading = useSelector(getIsPropertyLoading);
  const isExclusiveLoading = useSelector(getIsExclusiveLoading);
  const exclusiveOffer = useSelector(getExclusiveOffer);
  const isVisible = isExclusive && !isPropertyLoading && !isExclusiveLoading && !exclusiveOffer;

  useEffect(() => {
    if (isVisible) {
      openDialog();
    }
  }, [isVisible, openDialog]);

  const handleOnClick = () => {
    emitInteractionEvent({ type: 'Exclusive Offer Unavailable Dialog', value: 'Explore Button Clicked' });
  };

  return (
    <Dialog>
      <Flex alignItems="center" flexDirection="column">
        <Heading.h2 fontWeight="normal" mb={4} textAlign="center">
          This offer is no longer available, please explore other exclusive offers.
        </Heading.h2>
        <Text display="block" mb={4} textAlign="center">
          If you need further assistance{` `}
          <ContactLinks />. <CallCenterHours />.
        </Text>
        <Button as="a" href="/hotels/exclusive-offers" variant="primary" mt={4} width={['100%', 'auto']} onClick={handleOnClick}>
          Explore exclusive offers
        </Button>
      </Flex>
    </Dialog>
  );
});

ExclusiveOfferUnavailableDialog.displayName = 'ExclusiveOfferUnavailableDialog';

export default ExclusiveOfferUnavailableDialog;
